import { licencedPharmaciesBanner } from "@/assets/images";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";

const OnlyLicencedPharmaciesBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <>
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        We only work with licensed compounding pharmacies. All our medication go
        through an extreme vetting process before arriving at your door.
      </p>
      <img
        src={licencedPharmaciesBanner}
        className="mx-auto"
        alt="Only licenced pharmacies"
      />

      <Button onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { OnlyLicencedPharmaciesBanner };
